export const strings = {
  // base_image_url: "https://property-website.backend.trinarybits.com",
  // base_url_web: "https://property-website.backend.trinarybits.com/",
  // base_url: "https://property.backend.trinarybits.com/api/",

  // RAHUL local
  // base_url_web: "http://192.168.8.149:5022/",
  //  base_url: "http://192.168.8.149:5022/api/",

  // ASHISH local
  // base_url_web: "http://192.168.8.110:3030/",
  //  base_url: "http://192.168.8.110:3030/api/",

  //BISHAL LOCAL
  //  base_url_web: "http://192.168.8.102:5022/",
  //  base_url: "http://192.168.8.102:5022/api/",
  //    base_image_url: "https://test.addressbox.com",

  base_url_web: process.env.REACT_APP_BASE_URL_WEB,
  base_url: process.env.REACT_APP_BASE_URL,
  base_image_url: process.env.REACT_APP_BASE_IMAGE_URL,
  message_service_url: process.env.REACT_APP_MESSAGE_SERVICE_URL,
  function_based_url: process.env.REACT_APP_BASE_IMAGE_URL,
  pid_key_property: process.env.REACT_APP_PID_KEY_PROPERTY,
  pid_key_project: process.env.REACT_APP_PID_KEY_PROJECT,
};
//

// LOCAL SWAGGER
